import React from "react";
import { Box, Text } from "rebass";

import { NavLink } from "./NavLink";

import { Link } from "../../../utils/createLinksAndRoutes";

interface IProps {
  links: Array<Link>;
  title: string;
  url: string;
}

export const LinkSection: React.FC<IProps> = ({ links, title, url }) => (
  <Box as="section">
    <Text
      p="30px 25px 10px"
      fontSize="18px"
      fontWeight="bold"
      color="#2b3160"
    >
      {title}
    </Text>

    <Box>
      {
        links.map(({ path, link }) => (
          <NavLink
            key={path}
            to={location => ({ ...location, pathname: `${url}/${path}` })}
            {...link}
          />
        ))
      }
    </Box>
  </Box>
);
